import { PayPalButtonsComponentProps } from '@paypal/react-paypal-js'
import { Appearance } from '@stripe/stripe-js'

import { PaymentScreenVersion } from '@/enums/paymentScreenVersion'

import { PAYMENT_SCREEN_VERSION } from './pages/constants'

const currentPaymentScreenVersion = PAYMENT_SCREEN_VERSION as PaymentScreenVersion

const versionLabelStyles: Partial<
  Record<PaymentScreenVersion, { fontSize: string; fontWeight: string; marginBottom: string }>
> = {
  [PaymentScreenVersion.v3_2]: { fontSize: '12px', fontWeight: '800', marginBottom: '11px' },
  [PaymentScreenVersion.v3_3]: { fontSize: '12px', fontWeight: '800', marginBottom: '11px' },
  [PaymentScreenVersion.v3_4]: { fontSize: '12px', fontWeight: '500', marginBottom: '0' },
}

const defaultLabelStyle = { fontSize: '15px', fontWeight: '800', marginBottom: '4px' }

const labelStyles = versionLabelStyles[currentPaymentScreenVersion] || defaultLabelStyle

const customPaymentScreenVersions = [
  PaymentScreenVersion.v3_2,
  PaymentScreenVersion.v3_3,
  PaymentScreenVersion.v3_4,
]

const isCustomPaymentScreen = customPaymentScreenVersions.includes(currentPaymentScreenVersion)

export const stripeFormAppearance: Appearance = {
  theme: 'flat',
  variables: {
    colorBackground: 'white',
    fontFamily: 'roboto, system-ui, serif',
    borderRadius: '8px',
    colorText: '#000',
    colorPrimaryText: '#000',

    colorIconCardCvc: 'transparent',
    colorIconCardCvcError: 'transparent',
    colorIconCardError: 'transparent',
    colorIcon: 'transparent',
    colorTextPlaceholder: '#9ca3af',
    colorTextSecondary: '#90918E',
    colorDanger: '#ff3932',
    colorSuccessText: '#2EAB35',
  },
  rules: {
    '.Input': {
      border: `1px solid ${isCustomPaymentScreen ? '#D9D9D9' : '#90918E'}`,
      outline: 'none',
    },
    '.Input--invalid': {
      border: `1px solid #ff3932`,
    },
    '.Input:focus': {
      border: `1px solid #000`,
    },
    '.Label': {
      ...labelStyles,
    },
  },
}

export const paypalButtonConfigStyle: PayPalButtonsComponentProps = {
  style: {
    color: 'gold',
    layout: 'horizontal',
    height: 55,
    tagline: false,
    shape: 'rect',
    label: 'paypal',
  },
}
